import _ from "underscore";

import template from '../templates/criteria.jst';

import View from "backdraft-app/src/view";

function totalPhraseSaidCountOpts() {
  return _.map(_.range(1, 6), num => ({
    value: num,
    label: pluralize(num, 'time')
  }));
}

function pluralize(count, singular) {
  return `${count} ${(count === 1) ? singular : `${singular}s`}`;
}

export default class KeywordsCriteria extends View {
  get bindings() {
    return {
      ":radio[name='any_or_all']": "any_or_all",
      "select[name='total_phrase_said_count']": {
        observe: "total_phrase_said_count",
        selectOptions: {
          collection: totalPhraseSaidCountOpts()
        }
      },
      "select[name='uniq_phrase_said_count']": {
        observe: "uniq_phrase_said_count",
        selectOptions: {
          collection() {
            return _.map(_.range(1, this.model.keywords.length + 1), num => ({
              value: num,
              label: `Any ${num}`
            }));
          }
        }
      }
    };
  }

  initialize(options) {
    super.initialize(options);

    options = _.defaults(options || {}, { editable: true });
    this.editable = options.editable;
  }

  render() {
    this.$el.html(template({ model: this.model, editable: this.editable }));
    this._wireEvents();
    this.stickit();
    return this;
  }

  _wireEvents() {
    this.listenTo(this.model.keywords, "reset add", (model, value) => {
      // Rebuild options in the dropdown
      this._updateUniqPhraseSaidOptions();
    });

    this.listenTo(this.model.keywords, "remove", function() {
      const oldValue = this.model.get('uniq_phrase_said_count');
      const newMaxValue = this.model.keywords.length;

      // If the "max" option is currently selected...
      if (oldValue > newMaxValue) {
        // ...select its neighbor option - because max option is getting removed.
        this.model.set("uniq_phrase_said_count", newMaxValue, { syntheticUpdate: true });
      } else {
        // ...else - preserve existing option and simply rebuild options in the dropdown.
        this._updateUniqPhraseSaidOptions();
      }
    });

    this.listenTo(this.model, "change:any_or_all", (model, value) => {
      if (value === "all" && !model.get("total_phrase_said_count")) {
        model.set("total_phrase_said_count", 1);
      } else if (value === "any" && !model.get("uniq_phrase_said_count")) {
        model.set("uniq_phrase_said_count", 1);
      }
    });

    this.listenTo(this.model, "change:uniq_phrase_said_count", function(model, value, { syntheticUpdate }) {
      // If this change was user-triggered
      if (!syntheticUpdate) {
        this.$('input[name=any_or_all][value=any]').prop("checked", true).change();
      }
    });

    this.listenTo(this.model, "change:total_phrase_said_count", function(model, value) {
      this.$('input[name=any_or_all][value=all]').prop("checked", true).change();
    });
  }

  _updateUniqPhraseSaidOptions() {
    // Trigger a 'change' event with the existing (current) value.
    //
    // This will cause stickit to regenerate a list of options in the dropdown
    // by calling a function in the 'collection' attribute (see above).
    //
    // 'syntheticUpdate' option can be used in change callbacks to differentiate between
    // user-triggered change events and this (synthetic) change event.
    const oldValue = this.model.get('uniq_phrase_said_count');
    this.model.trigger('change:uniq_phrase_said_count', this.model, oldValue, { syntheticUpdate: true });
  }
}
